var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { message } from "antd";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerDetailsView } from "../core";
import LabelForm from "./components/LabelsForm";
const LabelsDetailsView = observer(({ entityId, operation, onCancel, onCompleted, }) => {
    const { labels } = useStore();
    const [loading, setLoading] = useState(false);
    const entity = (() => {
        if (!entityId || operation === Operation.CREATE)
            return null;
        return labels.labels.find((l) => l.id === entityId) || null;
    })();
    const renderDeleteQuestion = (label) => {
        return React.createElement(Trans, { i18nKey: "deleteLabelName", values: { name: label.name } });
    };
    const handleSave = (formData, existingEntity) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const payload = {
            name: formData.name,
            color: formData.color,
            id: formData.id,
        };
        try {
            if (existingEntity) {
                yield labels.editLabel(Object.assign(Object.assign({}, payload), { id: existingEntity.id }));
                message.success(React.createElement(Trans, { i18nKey: "labelEditSuccess", values: { name: payload.name } }));
            }
            else {
                yield labels.createLabel(payload);
                message.success(React.createElement(Trans, { i18nKey: "labelCreateSuccess", values: { name: payload.name } }));
            }
        }
        catch (error) {
            console.error("Failed to save label:", error);
            message.error(React.createElement(Trans, { i18nKey: "labelSaveError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    const handleDelete = (label) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield labels.deleteLabel(label.id);
            message.success(React.createElement(Trans, { i18nKey: "labelDeleteSuccess", values: { name: label.name } }));
        }
        catch (error) {
            console.error("Failed to delete label:", error);
            message.error(React.createElement(Trans, { i18nKey: "labelDeleteError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    return (React.createElement(ManagerDetailsView, { entity: entity, entityId: entityId, operation: operation, form: LabelForm, loading: loading, initialLoading: !labels.labelsFetched, renderDeleteQuestion: renderDeleteQuestion, onEntitySave: handleSave, onEntityDelete: handleDelete, onCancel: onCancel, onSaveCompleted: onCompleted, onDeleteCompleted: onCompleted }));
});
export default LabelsDetailsView;
